import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, App } from 'antd'; // 必须引入 App
import { setLogout } from '../store/loginSlice';
import { useDispatch } from 'react-redux';
import { PoweroffOutlined ,UserOutlined,MobileOutlined,SettingOutlined} from '@ant-design/icons';
import { resetMain } from '../store/mainSlice';
import { useYonghuDelSheBeiMutation } from '../store/DianShangYeWuApi';

function MainLogout(props) {    
    const navi = useNavigate();
    const dispatch = useDispatch();
    const { modal } = App.useApp(); // 正确获取 modal 方法
    const [del] = useYonghuDelSheBeiMutation()
    const logout = useCallback(() => {
        del({yh_phone:props.yh_phone})
        navi('/WebLogin');
        dispatch(setLogout());
        dispatch(resetMain()); 
    }, [del, dispatch, navi, props.yh_phone]);

    const handleLogoutClick = useCallback(() => {
        // 确保 modal.confirm 被正确调用
        modal.confirm({
            title: <Space orientation='vertical'>
                
                <Space><UserOutlined /> {props.yh_name}</Space>
                <Space><MobileOutlined /> {props.yh_phone}</Space>
                <Space><SettingOutlined /> {props.yh_qx +'权限'}</Space>
            </Space>,
            icon: <></>,
            content: '',
            okText: '退出登录',
            cancelText: '取消',
            onOk: logout, // 直接引用 logout 函数
        });
    }, [modal, logout,props]);

    return (
        <Space onClick={handleLogoutClick} style={{ cursor: "pointer" }}>            
            <span>{props.yh_name}</span>
            <span>{props.yh_phone}</span>
            <span>{props.yh_qx}权限</span>
            <PoweroffOutlined style={{ fontSize: "16px" }} />退出登录
        </Space>
    );
}

export default MainLogout;